import { formatCurrency } from "../lib/affiliateAnalytics";

export default function Top10Partners({ analytics, loading }) {
  const rows = [...(analytics?.rows || [])]
    .sort((left, right) => right.volShare + right.revShare - (left.volShare + left.revShare))
    .slice(0, 10);

  return (
    <section className="overflow-hidden rounded-[32px] border border-white/10 bg-[rgba(11,18,31,0.92)] shadow-[0_30px_80px_rgba(0,0,0,0.28)]">
      <div className="border-b border-white/10 px-6 py-5">
        <div className="text-xs uppercase tracking-[0.28em] text-[var(--aff-muted)]">
          Leaderboard
        </div>
        <h2 className="mt-2 text-2xl font-black text-white">Top referred players by share value</h2>
      </div>

      <div className="overflow-x-auto">
        <table className="min-w-full text-left text-sm">
          <thead className="border-b border-white/10 bg-white/[0.03] text-[11px] uppercase tracking-[0.24em] text-[var(--aff-muted)]">
            <tr>
              <th className="px-5 py-4">Rank</th>
              <th className="px-5 py-4">Trader</th>
              <th className="px-5 py-4">Program</th>
              <th className="px-5 py-4">Turnover</th>
              <th className="px-5 py-4">Commission</th>
            </tr>
          </thead>
          <tbody>
            {loading ? (
              <EmptyRow label="Loading leaderboard..." />
            ) : rows.length ? (
              rows.map((row, index) => (
                <tr key={row.id} className="border-b border-white/6 text-slate-200">
                  <td className="px-5 py-4 font-black text-white">#{index + 1}</td>
                  <td className="px-5 py-4">
                    <div className="font-semibold text-white">{row.trader}</div>
                    <div className="text-xs text-slate-400">{row.traderMeta}</div>
                  </td>
                  <td className="px-5 py-4">
                    {row.program === "revenue" ? "Revenue share" : "Turnover share"}
                  </td>
                  <td className="px-5 py-4">{formatCurrency(row.turnover)}</td>
                  <td className="px-5 py-4 font-semibold text-emerald-300">
                    {formatCurrency((row.volShare || 0) + (row.revShare || 0))}
                  </td>
                </tr>
              ))
            ) : (
              <EmptyRow label="No leaderboard data yet." />
            )}
          </tbody>
        </table>
      </div>
    </section>
  );
}

function EmptyRow({ label }) {
  return (
    <tr>
      <td colSpan={5} className="px-5 py-12 text-center text-sm text-slate-400">
        {label}
      </td>
    </tr>
  );
}
